import { FC, Fragment, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import toast, { Toaster } from 'react-hot-toast';

import PhotoViewer from 'photoviewer';
import clsx from 'clsx';

import {
    actionGetSingleReportSettings,
    actionGetAgregateReportItem,
    actionGetUserSingleReport,
    actionDeleteReportPhotos,
    actionDownloadNewPhotos,
    actionUpdateReportNotes,
    actionGetCriteriasList,
    actionShowTunderSignal,
    actionGetTechCardData,
    mapPosStatusToName, actionUpdateReportEmployeeFeedback,
} from '../../../redux/action/userSingleReport/actionUserSingleReport';
import {
  reducerSingleReportSettingsOptions,
  reducerDeletePhotosId,
  reducerReportStatus,
} from '../../../redux/reducer/userSingleReport/reducers/userSingleReport';
import { calculateProgress } from '../../../utils/calculateUploadingProgress';
import {formatDateTime, formatDate, getCorrectDate} from '../../../utils/formatDate';
import { generateStyles } from '../../../utils/generateToastStyles';
import { createItemsArray } from '../../../utils/createPhotoArray';
import { getLabelByValue } from '../../../utils/getLabelByValue';
import { AppDispatch } from '../../../redux/reducer/store';

import ClientReportCheckTableSection from './adminSections/ClientReportCheckTableSection';
import SkuActionsTableSection from './adminSections/ReportSkuActionsTableSection';
import ReportCheckTableSection from './adminSections/ReportCheckTableSection';
import AdminPhotosTableSection from './adminSections/AdminPhotosTableSection';
import ActionTableSection from './adminSections/ReportActionsTableSection';
import SkuCvTableSection from './adminSections/ReportSkuCvTableSection';
import AdminHistorySection from './adminSections/AdminHistorySection';
import SkusTableSection from './adminSections/ReportSkusTableSection';
import CvTableSection from './adminSections/ReportCvTableSection';
import ToastPopup from '../../custom/toastPopup/toastPopup';
import EditPopup from '../../custom/editPopup/editPopup';
import YandexMap from '../../custom/yandexMap/yandexMap';
import Switcher from '../../custom/switcher/switcher';

import FileClose from '../../../assets/icons/fileClose.svg';
import ArrowIcon from '../../../assets/icons/chevron.svg';

import '../../../scss/photoviewer.scss';
import '../table.scss';
import { IUserOptions } from '../../../types/interfaces';
import {IEmployeeFeedbackOptions} from "../../../types/reportsInterfaces";

const statusOptions = [
  { value: 'NotChecked', label: 'Не проверен' },
  { value: 'Rejected', label: 'Отклонен' },
  { value: 'Cancelled', label: 'Отменен' },
  { value: 'Approved', label: 'Принят' },
];

const requestStatusOptions = [
  {
    status: 200,
    purpose: 'deletePhotos',
    successMessage: 'Выбранные фотографии успешно удалены!',
  },
  {
    status: 0,
    purpose: 'deletePhotos',
    errorMessage: 'При удалении фотографий произошла ошибка!',
  },
  {
    status: 200,
    purpose: 'copy',
    successMessage: 'Отчет успешно скопирован!',
  },
  {
    status: 0,
    purpose: 'copy',
    errorMessage: 'При копировании отчета произошла ошибка!',
  },
  {
    status: 200,
    purpose: 'addPhotos',
    successMessage: 'Фотографии успешно добавлены!',
  },
  {
    status: 200,
    purpose: 'changeHotline',
    successMessage: 'Данные успешно обновлены!',
  },
  {
    status: 0,
    purpose: 'addPhotos',
    errorMessage: 'При добавлении фотографий произошла ошибка!',
  },
  {
    status: 0,
    purpose: 'declineRateStatus',
    errorMessage: 'При изменении статуса произошла ошибка!',
  },
  {
    status: 0,
    purpose: 'changeHotline',
    errorMessage: 'Заполните значение!',
  },
];

const IS_VISIBLE_SIDEBAR = process.env.REACT_APP_IS_VISIBLE_SIDEBAR;

const TableAdminSingleReport: FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { id } = useParams<{ id: string }>();

  const { isOpenSidebar } = useSelector(
    (state: IUserOptions) => state.user.user,
  );
  const {
    initialAdminReportOptions,
    filteredReviewHistory,
    filteredRateHistory,
    sortedNearReports,
    reorderedOptions,
    requestPurpose,
    adminSettings,
    techCardData,
    beforeMedias,
    afterMedias,
    allHistory,
    status,
    report,
    files,
    reportEmployeeFeedbacks,
  } = useSelector((state: any) => state.userSingleReport.userSingleReport);
  const { claims } = useSelector((state: IUserOptions) => state.user.user.data);
  const {data} = useSelector((state: IUserOptions) => state.user.user);

    const [openRevisionDatePopupIndex, setOpenRevisionDatePopupIndex] =
    useState<number>(-1);
  const [currentReviewHistoryPage, setCurrentReviewHistoryPage] =
    useState<number>(1);
  const [currentRateHistoryPage, setCurrentRateHistoryPage] =
    useState<number>(1);
  const [openRevisionPopupIndex, setOpenRevisionPopupIndex] =
    useState<number>(-1);
  const [isOpenEditComment, setIsOpenEditComment] = useState<boolean>(false);
  const [isOpenEditFeedback, setIsOpenEditFeedback] = useState<boolean>(false);
  const [openDatePopupIndex, setOpenDatePopupIndex] = useState<number>(-1);
  const [currentHistoryPage, setCurrentHistoryPage] = useState<number>(1);
  const [isRevisionPhoto, setIsRevisionPhoto] = useState<boolean>(false);
  const [selectedPlanogram, setSelectedPlanogram] = useState<string | null>(
    null,
  );
  const [selectedSkusPhoto, setSelectedSkusPhoto] = useState<string | null>(
    null,
  );
  const [newCommentValue, setNewCommentValue] = useState<string>('');
  const [feedBackAnswerValue, setFeedBackAnswerValue] = useState<string>('');
  const [uploadProgress, setUploadProgress] = useState<number[]>([]);
  const [openPopupIndex, setOpenPopupIndex] = useState<number>(-1);
  const [selectedPhoto, setSelectedPhoto] = useState<any>(null);
  const [selectedAfterPhoto, setSelectedAfterPhoto] = useState<any>(null);
  const [selectedFiles, setSelectedFiles] = useState<File[]>([]);
  const [isVisibleData, setIsVisibleData] = useState<boolean>(true);
  const [isVisibleDataGeo, setIsVisibleDataGeo] = useState<boolean>(true);
  const [isVisibleDataInfo, setIsVisibleDataInfo] = useState<boolean>(true);
  const [isVisibleDataFiles, setIsVisibleDataFiles] = useState<boolean>(true);
  const [isVisibleDataPlanogramms, setIsVisibleDataPlanogramms] =
    useState<boolean>(true);

  const photoViewerInstance = document.querySelector('.photoviewer-modal');
  const previousReportIdRef = useRef<string | null>(null);
  const modalRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    console.log('[beforeMedias]', beforeMedias);
  }, [beforeMedias]);

  useEffect(() => {
    dispatch(actionGetSingleReportSettings('adminReport'));
    dispatch(actionGetUserSingleReport(id as string));
    dispatch(actionGetAgregateReportItem(id));
    dispatch(reducerDeletePhotosId([]));
  }, [dispatch, id]);

  useEffect(() => {
    if (report && report?.reportId?.id) {
      if (previousReportIdRef.current !== report?.reportId?.id) {
        dispatch(actionGetCriteriasList(report?.contract?.id));
        dispatch(actionGetTechCardData(report.pos.pos.id));
        if (claims.includes('admin') || claims.includes('tander:view')) {
          dispatch(
            actionShowTunderSignal({
              contractId: report && report?.contract?.id,
              posId: report && report?.pos?.pos?.id,
              date: report && report?.expected,
            }),
          );
        }

        if (initialAdminReportOptions && reorderedOptions) {
          const optionsToDelete =
            reorderedOptions &&
            reorderedOptions.filter(
              (option: { value: string; label: string }) =>
                initialAdminReportOptions &&
                !initialAdminReportOptions.some(
                  (elem: { value: string; label: string }) =>
                    option.value === elem.value,
                ),
            );

          const optionsToAdd =
            initialAdminReportOptions &&
            initialAdminReportOptions.filter(
              (option: { value: string; label: string }) =>
                reorderedOptions &&
                !reorderedOptions.some(
                  (elem: { value: string; label: string }) =>
                    option.value === elem.value,
                ),
            );

          const updatedOptions = reorderedOptions &&
            initialAdminReportOptions && [
              ...(reorderedOptions || initialAdminReportOptions)?.filter(
                (option: { value: string; label: string }) =>
                  optionsToDelete &&
                  !optionsToDelete.some(
                    (elem: { value: string; label: string }) =>
                      option.value === elem.value,
                  ),
              ),
              ...optionsToAdd,
            ];

          updatedOptions &&
            dispatch(
              reducerSingleReportSettingsOptions({
                entity: updatedOptions,
              }),
            );
        }
      }
      previousReportIdRef.current = report.reportId.id;
    }
  }, [dispatch, initialAdminReportOptions, claims, reorderedOptions, report]);

  useEffect(() => {
    requestStatusOptions.forEach((option) => {
      if (status === option.status && requestPurpose === option.purpose) {
        toast(
          (t) => (
            <ToastPopup
              title={
                option.successMessage
                  ? option.successMessage
                  : option.errorMessage
              }
              isSuccess={option.successMessage ? true : false}
              toast={toast}
              t={t}
            />
          ),
          generateStyles(option.successMessage ? true : false),
        );
      }
    });

    setTimeout(() => {
      dispatch(reducerReportStatus(null));
    }, 5000);
  }, [dispatch, report, requestPurpose, status]);

  useEffect(() => {
    const uploadRequests: XMLHttpRequest[] = [];

    selectedFiles.forEach((file: File, index: number) => {
      const formData = new FormData();
      formData.append('file', file);

      const xhr = new XMLHttpRequest();
      xhr.upload.addEventListener('progress', (event) => {
        if (event.lengthComputable) {
          calculateProgress(
            setUploadProgress,
            index,
            event.loaded,
            event.total,
          );
        }
      });

      xhr.addEventListener('load', () => {
        calculateProgress(setUploadProgress, index, file.size, file.size);
      });

      xhr.open('POST', '/upload-endpoint');
      xhr.send(formData);
      uploadRequests.push(xhr);
    });

    return () => {
      uploadRequests.forEach((xhr) => xhr.abort());
    };
  }, [selectedFiles]);

  useEffect(() => {
    const openPhotoViewer = (
      items: { src: string; title?: string }[],
      selected: string | null,
    ) => {
      if (selected) {
        const index = items.findIndex((item: { src: string; title?: string }) =>
          item?.src?.includes(selected),
        );

        const options = {
          index: index,
          callbacks: {
            opened: (context: any, index?: number | undefined) => {
              if (context.groupIndex === 0) {
                context.$prev.selector[0].style.opacity = 0;
                context.$prev.selector[0].disabled = true;
              } else if (context.groupIndex === items.length - 1) {
                context.$next.selector[0].style.opacity = 0;
                context.$next.selector[0].disabled = true;
              } else {
                context.$next.selector[0].style.opacity = 1;
                context.$next.selector[0].disabled = false;
                context.$prev.selector[0].style.opacity = 1;
                context.$prev.selector[0].disabled = false;
              }
            },
            changed: (context: any, index?: number | undefined) => {
              if (index === items.length - 1) {
                context.$next.selector[0].style.opacity = 0;
                context.$next.selector[0].disabled = true;
              } else if (index === 0) {
                context.$prev.selector[0].style.opacity = 0;
                context.$prev.selector[0].disabled = true;
              } else {
                context.$next.selector[0].style.opacity = 1;
                context.$next.selector[0].disabled = false;
                context.$prev.selector[0].style.opacity = 1;
                context.$prev.selector[0].disabled = false;
              }
            },
          },
        };

        if (photoViewerInstance) {
          photoViewerInstance.remove();
        }

        new PhotoViewer(items, options);
      }
    };

    if (selectedPhoto) {
      const items = createItemsArray(beforeMedias, 'media.name');
      openPhotoViewer(items, selectedPhoto);
      setSelectedPhoto(null);
    }

    if (selectedAfterPhoto) {
      const items = createItemsArray(afterMedias, 'media.name');
      openPhotoViewer(items, selectedAfterPhoto);
      setSelectedAfterPhoto(null);
    }

    if (selectedPlanogram) {
      const items = createItemsArray(report.planograms);
      openPhotoViewer(items, selectedPlanogram);
      setSelectedPlanogram(null);
    }

    if (selectedSkusPhoto) {
      const items = createItemsArray(report.skus, 'sku.name');
      openPhotoViewer(items, selectedSkusPhoto);
      setSelectedSkusPhoto(null);
    }
  }, [
    photoViewerInstance,
    selectedAfterPhoto,
    selectedSkusPhoto,
    selectedPlanogram,
    selectedPhoto,
    beforeMedias,
    afterMedias,
    report,
  ]);

  useEffect(() => {
    document.addEventListener('mousedown', handleDocumentClick);

    return () => {
      document.removeEventListener('mousedown', handleDocumentClick);
    };
  }, []);

  const handleClickAcceptEditComment = () => {
    dispatch(
      actionUpdateReportNotes({
        reportId: report && report.reportId.id,
        data: {
          note: newCommentValue || (report && report.notes),
        },
      }),
    );

    setIsOpenEditComment(false);
  };

    const handleClickAcceptEditFeedback = (feedback: IEmployeeFeedbackOptions) => {
        dispatch(
            actionUpdateReportEmployeeFeedback({
                                        reportId: report && report.reportId.id,
                                        data: {
                                            id: feedback.id,
                                            employee: { id: feedback.employee.id },
                                            report: { id: report.reportId.id },
                                            feedback: feedback.feedback,
                                            feedbackDate: feedback.feedbackDate,
                                            answerEmployee: { id: data.id},
                                            answer: feedBackAnswerValue || (feedback && feedback.answer),
                                            answerDate: getCorrectDate(new Date())
                                        },
                                    }),
        );

        setIsOpenEditFeedback(false);
    };

  const handleAcceptEditOnKeyPress = (
    event: KeyboardEvent,
    purpose: string,
    obj: any,
  ) => {
    if (event.key === 'Enter') {
      if (purpose === 'reportNotes') {
        handleClickAcceptEditComment();
      }
      if (purpose === 'reportFeedbacks') {
          handleClickAcceptEditFeedback(obj);
      }
    }
  };

  const handleDocumentClick = (event: MouseEvent) => {
    if (modalRef.current && !modalRef.current.contains(event.target as Node)) {
      setOpenRevisionDatePopupIndex(-1);
      setOpenRevisionPopupIndex(-1);
      setIsOpenEditComment(false);
      setOpenDatePopupIndex(-1);
      setOpenPopupIndex(-1);
    }
  };

  const handleClickDeleteFileBtn = (id: number) => {
    dispatch(
      actionDeleteReportPhotos({
        reportId: report && report.reportId.id,
        medias: [[{ id: id }]],
      }),
    );
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (files) {
      const filesArray = Array.from(files) as File[];
      setSelectedFiles([...selectedFiles, ...filesArray]);
    }
  };

  const handleClickDownloadNewPhotosBtn = () => {
    if (selectedFiles.length) {
      dispatch(
        actionDownloadNewPhotos({
          reportId: report && report.reportId.id,
          revision: isRevisionPhoto,
          files: selectedFiles,
        }),
      );
    }

    setSelectedFiles([]);
    const fileInput = document.getElementById('file') as HTMLInputElement;
    if (fileInput) {
      fileInput.value = '';
    }
  };

  const scrollModal = () => {
    if (modalRef.current) {
      modalRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
      });
    }
  };

  const handleNearReportClick = () => {
    if (photoViewerInstance) {
      photoViewerInstance.remove();
    }
  };
  return (
    <>
      <div
        className={clsx(
          JSON.parse(IS_VISIBLE_SIDEBAR as string) &&
            isOpenSidebar &&
            'customerSingle__report_activeTable',
          !isOpenSidebar && 'customerSingle__report_closedTable',
          'fixed__singleReport_tabs',
        )}
      >
        {' '}
        {JSON.parse(IS_VISIBLE_SIDEBAR as string)}
        <div className='report__reports_block'>
          {report &&
            sortedNearReports.map((nearRep: any, index: number) => (
              <div className='fixed__singleReport_tabs' key={index}>
                <div className='report__reports_block'>
                  <Link
                    to={`/reports/${nearRep.report.id}`}
                    key={index}
                    className={
                      nearRep.report.id.toString() === (id as string)
                        ? 'report__block active__report'
                        : 'report__block'
                    }
                    onClick={handleNearReportClick}
                  >
                    Отчет №{nearRep.report.id}{' '}
                    {nearRep.date.split('-').reverse().join('.')}
                    <div className='report__block_title'>
                      {nearRep.employee.name}
                    </div>
                  </Link>
                </div>
              </div>
            ))}
        </div>
      </div>
      <div
        className={clsx(
          JSON.parse(IS_VISIBLE_SIDEBAR as string) &&
            isOpenSidebar &&
            'customerSingle__report_activeTable',
          !isOpenSidebar && 'customerSingle__report_closedTable',
          'customerSingle__report_table',
        )}
      >
        {status && status !== null && (
          <Toaster
            position='top-center'
            toastOptions={{
              duration: 5000,
            }}
          />
        )}
        {report && report.trainee && (
          <div className='report__trainee_block'>
            <span>Отчет сдан стажером..</span>
          </div>
        )}
        {(reorderedOptions || initialAdminReportOptions)?.map(
          (elem: { value: string; label: string }, index: number) => {
            if (elem.value === 'mainInfo') {
              return (
                <div className={`customerReport__info_block`} key={index}>
                  {!isVisibleDataInfo && (
                    <span className='customer__info_title'>Торговая точка</span>
                  )}
                  <button
                    className='sectionData_button sectionData_button_info'
                    onClick={() => setIsVisibleDataInfo(!isVisibleDataInfo)}
                  >
                    <img
                      src={ArrowIcon}
                      alt='Custom Indicator'
                      className='icon'
                    />
                  </button>
                  {isVisibleDataInfo && (
                    <div className='customerReport__content'>
                      <div className='customer__info_row'>
                        <span>Регион</span>
                        <span>{report && report.pos.region}</span>
                      </div>
                      <div className='customer__info_row'>
                        <span>Торговая точка</span>
                        <span>
                          {report && report.chain}, г.
                          {report && report.pos.city}
                          {', '}
                          {report && report.pos.address}
                        </span>
                      </div>
                      <div className='customer__info_row'>
                        <span>Статус ТТ</span>
                        <span>
                          {report && mapPosStatusToName(report.pos.status)}{' '}
                          {report && report.pos?.statusToDate && formatDate(report.pos.statusToDate)}
                        </span>
                      </div>
                      <div className='customer__info_row'>
                        <span>Проект</span>
                        <span>{report && report.project}</span>
                      </div>
                      <div className='customer__info_row'>
                        <span>Контракт</span>
                        <span>{report && report.contract.name}</span>
                      </div>
                      <div className='customer__info_row'>
                        <span>Мерчендайзер</span>
                        <span>
                          {report && report?.merch?.familyName}{' '}
                          {report && report?.merch?.givenName}{' '}
                          {report && report?.merch?.middleName} (
                          {report && report?.merch?.login})
                        </span>
                      </div>
                      <div className='customer__info_row'>
                        <span>Супервайзер</span>
                        {report && report?.supervisor ? (
                          <span>
                            {report && report?.supervisor?.familyName}{' '}
                            {report && report?.supervisor?.givenName}{' '}
                            {report && report?.supervisor?.middleName}
                          </span>
                        ) : (
                          <span>—</span>
                        )}
                      </div>
                      <div className='customer__info_row'>
                        <span>Виртуальный супервайзер</span>
                        {report && report?.vsupervisor ? (
                          <span>
                            {report && report?.vsupervisor?.familyName}{' '}
                            {report && report?.vsupervisor?.givenName}{' '}
                            {report && report?.vsupervisor?.middleName} (
                            {report && report?.vsupervisor?.login})
                          </span>
                        ) : (
                          <span>—</span>
                        )}
                      </div>
                      <div className='customer__info_row'>
                        <span>Дата</span>
                        <span>{report && formatDate(report.expected)}</span>
                      </div>
                      <div className='customer__info_row'>
                        <span>Получен</span>
                        <span>
                          {report && report.reported
                            ? report && formatDateTime(report?.reported)
                            : ''}
                        </span>
                      </div>
                      {report && report.techInfo && (
                        <div className='customer__info_row'>
                          <span>Тех. информация</span>
                          <div className='disabled__info_block'>
                            <pre>{report && report.techInfo}</pre>
                          </div>
                        </div>
                      )}
                      {report && report.createdBy && (
                        <div className='customer__info_row'>
                          <span>Отчет создан</span>
                          <span>
                            {report && report?.createdBy?.familyName}{' '}
                            {report && report?.createdBy?.givenName}{' '}
                            {report && report?.createdBy?.middleName} (
                            {report && report?.createdBy?.login})
                          </span>
                        </div>
                      )}
                      {adminSettings.includes('easymerch') &&
                        report &&
                        report?.emReport && (
                          <div className='report__info__borderBlock'>
                            <span className='section__title'>Easy Merch</span>
                            <div className='border__block_section'>
                              <div className='border__block_elem'>
                                <span>Визит:</span>
                                <span>
                                  <a
                                    href={`https://rusagro.easymerch.ru/reports/?mode=view&id=${
                                      report && report?.emReport?.visitId
                                    }`}
                                    className='file__link'
                                    rel='noreferrer'
                                    target='_blank'
                                  >
                                    {report && report?.emReport?.visitId}
                                  </a>
                                </span>
                              </div>
                              <div className='border__block_elem'>
                                <span>Пользователь:</span>
                                <span>
                                  {report && report?.emReport?.userId}
                                </span>
                              </div>
                              <div className='border__block_elem'>
                                <span>Физ. лицо:</span>
                                <span>
                                  {report && report?.emReport?.personId}
                                </span>
                              </div>
                              <div className='border__block_elem'>
                                <span>Логин:</span>
                                <span>{report && report?.emReport?.login}</span>
                              </div>
                              <div className='border__block_elem'>
                                <span>Статус:</span>
                                <span>
                                  {report &&
                                    getLabelByValue(
                                      report?.emReport?.status,
                                      statusOptions,
                                    )}
                                </span>
                              </div>
                            </div>
                          </div>
                        )}
                        {adminSettings.includes('smartmerch') && report && report.sm && (
                            <div className='report__info__borderBlock'>
                                <span className='section__title inside'>Smart Merch</span>
                                <div className='border__block_section'>
                                    <div className='border__block_elem'>
                                        <span>Визит:</span>
                                        <span>{report && report.sm?.visitId}</span>
                                    </div>
                                </div>
                            </div>
                        )}
                      <div className='report__info__borderBlock'>
                        <span className='section__title inside'>
                          Время заполнения отчета
                        </span>
                        <div className='border__block_section'>
                          <div className='border__block_elem'>
                            <span>Начал:</span>
                            <span>
                              {report && report.startTime
                                ? report && formatDateTime(report?.startTime)
                                : ''}
                            </span>
                          </div>
                          <div className='border__block_elem'>
                            <span>Завершил:</span>
                            <span>
                              {report && report.endTime
                                ? report && formatDateTime(report?.endTime)
                                : ''}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className='report__info__borderBlock'>
                        <span className='section__title inside'>Финансы</span>
                        <div className='border__block_section'>
                          <div className='border__block_elem'>
                            <span>Стоимость план.:</span>
                            <span>{report && report.costs.costPlan} руб.</span>
                          </div>
                          <div className='border__block_elem'>
                            <span>Стоимость факт.:</span>
                            <span>
                              {report && report.costs.costFact} руб. (
                              {report && report.costs.costPercent}% )
                            </span>
                          </div>
                          <div className='border__block_elem'>
                            <span>Себестоимость план.:</span>
                            <span>
                              {report && report.costs.selfCostPlan} руб.
                            </span>
                          </div>
                          <div className='border__block_elem'>
                            <span>Себестоимость факт.:</span>
                            <span>
                              {report && report.costs.selfCostFact} руб. (
                              {report && report.costs.selfCostPercent}%)
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className='report__info__borderBlock'>
                        <div className='border__block_section'>
                          <div className='border__block_elem'>
                            <span>Статус</span>
                            <span
                              className={
                                report &&
                                Object.keys(
                                  report.deliveryStatus,
                                ).toString() === 'OnTime'
                                  ? 'greenText'
                                  : report &&
                                    Object.keys(
                                      report.deliveryStatus,
                                    ).toString() === 'Expired'
                                  ? 'yellowText'
                                  : 'redText'
                              }
                            >
                              {report && Object.values(report.deliveryStatus)}
                            </span>
                          </div>
                          <div className='border__block_elem'>
                            <span>ФИО сотрудника ТТ</span>
                            <span>{report && report.contactPerson}</span>
                          </div>
                          <div className='border__block_elem'>
                            <span>Комментарий</span>
                            <div className='edited__comment_block'>
                              {claims.includes('admin') ||
                              claims.includes('reports:edit') ? (
                                <div
                                  className='edited__coment_value'
                                  onClick={() => {
                                    setIsOpenEditComment(!isOpenEditComment);
                                    setTimeout(scrollModal, 0);
                                  }}
                                >
                                  {(report && report.notes) || ''}
                                </div>
                              ) : (
                                <div className='edited__coment_value'>
                                  {(report && report.notes) || ''}
                                </div>
                              )}
                              {isOpenEditComment && (
                                <EditPopup
                                  handleClickAcceptRenameBtn={() => {
                                    handleClickAcceptEditComment();
                                  }}
                                  handleAcceptOnKeyPress={(
                                    event: KeyboardEvent,
                                  ) =>
                                    handleAcceptEditOnKeyPress(
                                      event,
                                      'reportNotes',
                                      null,
                                    )
                                  }
                                  handleClickCancelRenameBtn={() => {
                                    setIsOpenEditComment(false);
                                  }}
                                  handleChangeValue={(
                                    event: React.ChangeEvent<HTMLInputElement>,
                                  ) => {
                                    setNewCommentValue(event?.target.value);
                                  }}
                                  defaultValue={
                                    newCommentValue || (report && report.notes)
                                  }
                                  className='edit__comment_popup'
                                  modalRef={modalRef}
                                />
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className='report__info__borderBlock'>
                        <div className='border__block_section'>
                          <div className='border__block_elem'>
                            <span>
                              Процент изменений по сравнению с предыдущим
                              отчетом
                            </span>
                            <span>0%</span>
                          </div>
                        </div>
                      </div>
                        {reportEmployeeFeedbacks?.length > 0 && (
                            <div className='report__info__borderBlock'>
                                <span className='section__title inside'>Обращения</span>
                                    {reportEmployeeFeedbacks?.map((feedback: IEmployeeFeedbackOptions, index: number) => (
                                        <div className='border__block_section'>
                                            <div className='border__block_elem'>
                                                <span>{(feedback && feedback.feedbackDate && formatDateTime(feedback.feedbackDate)) || (index + 1)}</span>
                                            </div>
                                            <div className='border__block_elem'>
                                                <span>Вопрос</span>
                                                <span>{(feedback && feedback.feedback) || ''}</span>
                                            </div>
                                            <div className='border__block_elem'>
                                                <span>Ответ</span>
                                                <div className='edited__comment_block'>
                                                    {claims.includes('admin') ||
                                                     claims.includes('reports:edit') ? (
                                                         <div
                                                             className='edited__coment_value'
                                                             onClick={() => {
                                                                 setIsOpenEditFeedback(!isOpenEditFeedback);
                                                                 setTimeout(scrollModal, 0);
                                                             }}
                                                         >
                                                             {(feedback && feedback.answer) || 'Добавить ответ на обращение'}
                                                         </div>
                                                     ) : (
                                                         <div className='edited__coment_value'>
                                                             {(feedback && feedback.answer) || ''}
                                                         </div>
                                                     )}
                                                    {isOpenEditFeedback && (
                                                        <EditPopup
                                                            handleClickAcceptRenameBtn={() => {
                                                                handleClickAcceptEditFeedback(feedback);
                                                            }}
                                                            handleAcceptOnKeyPress={(
                                                                event: KeyboardEvent,
                                                            ) =>
                                                                handleAcceptEditOnKeyPress(
                                                                    event,
                                                                    'reportFeedbacks',
                                                                    feedback,
                                                                )
                                                            }
                                                            handleClickCancelRenameBtn={() => {
                                                                setIsOpenEditFeedback(false);
                                                            }}
                                                            handleChangeValue={(
                                                                event: React.ChangeEvent<HTMLInputElement>,
                                                            ) => {
                                                                setFeedBackAnswerValue(event?.target.value);
                                                            }}
                                                            defaultValue={
                                                                feedBackAnswerValue || (feedback && feedback.answer)
                                                            }
                                                            className='edit__comment_popup'
                                                            modalRef={modalRef}
                                                        />
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                            </div>
                        )}
                    </div>
                  )}
                </div>
              );
            }

            if (elem.value === 'geo') {
              return (
                <Fragment key={index}>
                  {report &&
                    report?.pos?.longitude &&
                    report?.pos?.latitude &&
                    adminSettings.includes('geo') &&
                    previousReportIdRef.current === report?.reportId?.id && (
                      <div className='customer__geo_parentBlock'>
                        <div className='customerGeo__block'>
                          <div>
                            <span className='section__title inside'>
                              Координаты торговой точки
                            </span>

                            <button
                              className='sectionData_button'
                              onClick={() =>
                                setIsVisibleDataGeo(!isVisibleDataGeo)
                              }
                            >
                              <img
                                src={ArrowIcon}
                                alt='Custom Indicator'
                                className='icon'
                              />
                            </button>
                          </div>
                          {isVisibleDataGeo && <YandexMap />}
                        </div>
                      </div>
                    )}
                </Fragment>
              );
            }

            if (elem.value === 'photos') {
              return (
                <Fragment key={index}>
                  {adminSettings.includes('photos') &&
                    isVisibleDataInfo &&
                    (claims.includes('admin') ||
                      claims.includes('reports:edit')) && (
                      <div className='add__photo_wrapper'>
                        <div className='add__photo_block'>
                          <div className='add__photo_elem'>
                            <span>Добавьте фотографии:</span>
                          </div>
                          <div className='add__photo_elem'>
                            <input
                              className='download__file_input'
                              onChange={handleFileChange}
                              placeholder='Загрузить'
                              type='file'
                              name='file'
                              id='file'
                              multiple
                            />
                            <label htmlFor='file' className='file__label'>
                              Загрузить
                            </label>
                            <div className='file__list'>
                              {selectedFiles.map(
                                (file: File, index: number) => {
                                  const fileSize = (
                                    file.size /
                                    (1024 * 1024)
                                  ).toFixed(2);
                                  const progress = uploadProgress[index] || 0;

                                  return (
                                    <div
                                      key={index}
                                      className='file__list_elem'
                                    >
                                      <div className='file__list_dot'></div>
                                      <span className='file__name'>
                                        {file.name}
                                      </span>
                                      <span>
                                        {progress.toFixed(0)}% от {fileSize} MB
                                      </span>
                                      <span
                                        onClick={() => {
                                          setSelectedFiles(
                                            selectedFiles.filter(
                                              (elem: File) =>
                                                elem.name !== file.name,
                                            ),
                                          );
                                          const fileInput =
                                            document.getElementById(
                                              'file',
                                            ) as HTMLInputElement;
                                          if (fileInput) {
                                            fileInput.value = '';
                                          }
                                        }}
                                        className='cancel__file_btn'
                                      >
                                        Отменить
                                      </span>
                                    </div>
                                  );
                                },
                              )}
                            </div>
                            <button
                              onClick={handleClickDownloadNewPhotosBtn}
                              className='download__btn'
                            >
                              Добавить
                            </button>
                          </div>
                          <div className='switcher__block'>
                            <Switcher
                              checked={isRevisionPhoto}
                              onChange={() => {
                                setIsRevisionPhoto(!isRevisionPhoto);
                              }}
                            />
                            <span
                              className={
                                isRevisionPhoto
                                  ? 'active__switcher_title'
                                  : 'switcher__title'
                              }
                            >
                              Загрузить в блок "Доработка"
                            </span>
                          </div>
                        </div>
                      </div>
                    )}
                  {adminSettings.includes('photos') && (
                    <>
                      {!!beforeMedias?.length && (
                        <AdminPhotosTableSection
                          setOpenDatePopupIndex={setOpenDatePopupIndex}
                          previousReportIdRef={previousReportIdRef}
                          openDatePopupIndex={openDatePopupIndex}
                          setOpenPopupIndex={setOpenPopupIndex}
                          setSelectedPhoto={setSelectedPhoto}
                          openPopupIndex={openPopupIndex}
                          title='Фото при создании отчета'
                          scrollModal={scrollModal}
                          datePurpose='dateBefore'
                          medias={beforeMedias}
                          namePurpose='before'
                          modalRef={modalRef}
                        />
                      )}
                      {!!afterMedias?.length && (
                        <AdminPhotosTableSection
                          setOpenDatePopupIndex={setOpenRevisionDatePopupIndex}
                          openDatePopupIndex={openRevisionDatePopupIndex}
                          setOpenPopupIndex={setOpenRevisionPopupIndex}
                          previousReportIdRef={previousReportIdRef}
                          openPopupIndex={openRevisionPopupIndex}
                          setSelectedPhoto={setSelectedAfterPhoto}
                          title='Фото после доработки отчета'
                          scrollModal={scrollModal}
                          datePurpose='dateAfter'
                          medias={afterMedias}
                          namePurpose='after'
                          modalRef={modalRef}
                        />
                      )}
                    </>
                  )}
                </Fragment>
              );
            }

            if (elem.value === 'files') {
              return (
                <Fragment key={index}>
                  {report &&
                    !!files?.length &&
                    adminSettings.includes('files') && (
                      <div
                        className={`sectionData ${
                          isVisibleDataFiles ? 'sectionData_active' : ''
                        }`}
                      >
                        <span className='section__title'>Файлы отчета</span>
                        <button
                          className='sectionData_button sectionData_button_info'
                          onClick={() =>
                            setIsVisibleDataFiles(!isVisibleDataFiles)
                          }
                        >
                          <img
                            src={ArrowIcon}
                            alt='Custom Indicator'
                            className='icon'
                          />
                        </button>
                        <div className='report__files_section'>
                          {report &&
                            files?.map(
                              (
                                elem: { media: { id: number; name: string }, url: { link: string } },
                                index: number,
                              ) => (
                                <div
                                  key={elem.media.id}
                                  className='report__file_block'
                                >
                                  <Link
                                    className='file__link'
                                    to={`${elem.url.link}`}
                                    target='_blank'
                                  >
                                    {index + 1} файл
                                  </Link>
                                  <img
                                    onClick={() =>
                                      handleClickDeleteFileBtn(elem.media.id)
                                    }
                                    className='file__close_icon'
                                    src={FileClose}
                                    alt='close'
                                  />
                                </div>
                              ),
                            )}
                        </div>
                      </div>
                    )}
                </Fragment>
              );
            }

            if (elem.value === 'planogramms') {
              return (
                <Fragment key={index}>
                  {report &&
                    !!report?.planograms?.length &&
                    adminSettings.includes('planogramms') && (
                      <div
                        className={`sectionData ${
                          isVisibleDataPlanogramms ? 'sectionData_active' : ''
                        }`}
                      >
                        <span className='section__title'>Планограммы</span>
                        <button
                          className='sectionData_button'
                          onClick={() => {
                            setIsVisibleDataPlanogramms(
                              !isVisibleDataPlanogramms,
                            );
                          }}
                        >
                          <img
                            src={ArrowIcon}
                            alt='Custom Indicator'
                            className='icon'
                          />
                        </button>
                        <div className='planogramms__table'>
                          {report &&
                            report?.planograms?.map(
                              (
                                elem: {
                                  etag: string;
                                  url: {
                                    link: string;
                                    thumb: string;
                                  };
                                },
                                index: number,
                              ) => (
                                <img
                                  src={elem?.url?.thumb}
                                  onClick={() =>
                                    setSelectedPlanogram(elem?.url?.link)
                                  }
                                  className='planogram__photo'
                                  alt='planoram'
                                  key={index}
                                />
                              ),
                            )}
                        </div>
                      </div>
                    )}
                </Fragment>
              );
            }

            if (elem.value === 'cv') {
              return (
                <Fragment key={index}>
                  {report &&
                    !!report?.cv?.length &&
                    adminSettings.includes('cv') && <CvTableSection />}
                </Fragment>
              );
            }

            if (elem.value === 'skus') {
              return (
                <Fragment key={index}>
                  {report &&
                    !!report?.skus?.length &&
                    adminSettings.includes('skus') && (
                      <SkusTableSection
                        setSelectedSkusPhoto={setSelectedSkusPhoto}
                        previousReportIdRef={previousReportIdRef}
                      />
                    )}
                </Fragment>
              );
            }

            if (elem.value === 'skuCv') {
              return (
                <Fragment key={index}>
                  {report &&
                    !!report?.skuCv?.length &&
                    adminSettings.includes('skuCv') && <SkuCvTableSection />}
                </Fragment>
              );
            }

            if (elem.value === 'actionsTT') {
              return (
                <Fragment key={index}>
                  {report &&
                    !!report?.actions?.length &&
                    adminSettings.includes('actionsTT') &&
                    (claims.includes('admin') ||
                      claims.includes('reports:view')) && (
                      <ActionTableSection />
                    )}
                </Fragment>
              );
            }

            if (elem.value === 'actions') {
              return (
                <Fragment key={index}>
                  {report &&
                    !!report?.skuActions?.length &&
                    adminSettings.includes('actions') && (
                      <SkuActionsTableSection />
                    )}
                </Fragment>
              );
            }

            if (elem.value === 'review') {
              return (
                <Fragment key={index}>
                  {adminSettings.includes('review') && (
                    <div className='check__block'>
                      <ReportCheckTableSection />
                    </div>
                  )}
                </Fragment>
              );
            }

            if (elem.value === 'rate') {
              return (
                <Fragment key={index}>
                  {adminSettings.includes('rate') && (
                    <div className='check__block'>
                      {(claims.includes('admin') ||
                        claims.includes('reports:rate:view')) && (
                        <ClientReportCheckTableSection />
                      )}
                    </div>
                  )}
                </Fragment>
              );
            }

            if (elem.value === 'history') {
              return (
                <Fragment key={index}>
                  {report &&
                    !!filteredReviewHistory?.length &&
                    adminSettings.includes('history') && (
                      <AdminHistorySection
                        setCurrentHistoryPage={setCurrentReviewHistoryPage}
                        currentHistoryPage={currentReviewHistoryPage}
                        filteredHistory={filteredReviewHistory}
                        title='Изменения по проверке'
                      />
                    )}
                  {report &&
                    !!filteredRateHistory?.length &&
                    adminSettings.includes('history') && (
                      <AdminHistorySection
                        setCurrentHistoryPage={setCurrentRateHistoryPage}
                        currentHistoryPage={currentRateHistoryPage}
                        filteredHistory={filteredRateHistory}
                        title='Изменения по оценке'
                      />
                    )}
                  {report &&
                    !!allHistory?.length &&
                    adminSettings.includes('history') && (
                      <AdminHistorySection
                        setCurrentHistoryPage={setCurrentHistoryPage}
                        currentHistoryPage={currentHistoryPage}
                        title='Все изменения по отчету'
                        filteredHistory={allHistory}
                      />
                    )}
                </Fragment>
              );
            }

            if (elem.value === 'techCard') {
              return (
                <Fragment key={index}>
                  {adminSettings.includes('techCard') && (
                    <div
                      className={`sectionData ${
                        isVisibleData
                          ? 'sectionData_active sectionData__overflow'
                          : ''
                      }`}
                    >
                      <span className='section__title'>
                        Технологическая карта ТТ
                      </span>
                      <button
                        className='sectionData_button'
                        onClick={() => setIsVisibleData(!isVisibleData)}
                      >
                        <img
                          src={ArrowIcon}
                          alt='Custom Indicator'
                          className='icon'
                        />
                      </button>
                      <table className='tt__card_table'>
                        <thead className='tunder__thead'>
                          <tr>
                            <th>Вопрос</th>
                            <th>Значение</th>
                          </tr>
                        </thead>
                        <tbody>
                          {techCardData &&
                            techCardData.map(
                              (
                                elem: {
                                  list: { id: number };
                                  question: { id: number; name: string };
                                  value: string;
                                },
                                index: number,
                              ) => (
                                <tr key={index}>
                                  <td>{elem.question.name}</td>
                                  <td>{elem.value}</td>
                                </tr>
                              ),
                            )}
                        </tbody>
                      </table>
                    </div>
                  )}
                </Fragment>
              );
            }

            return null;
          },
        )}
      </div>
    </>
  );
};

export default TableAdminSingleReport;
